module.exports = __webpack_public_path__ + "static/N2N4-c339a86a065c607d413da1444538fde5.jpg";